import { atom } from 'jotai';
import { DEFAULT_PAGINATION } from '@/common/pagination/types.ts';

export const templatePaginationAtom = atom(DEFAULT_PAGINATION);

export const resetTemplatePaginationOnFilterChangeAtom = atom(
  null,
  (_get, set) => set(templatePaginationAtom, DEFAULT_PAGINATION),
);
